// import React, { useState, useEffect } from 'react';
// import '../css/components/ManageProfile.css';
// import Loading from '../general/Loading';

// const indianStates = [
//   'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
//   'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
//   'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
//   'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
//   'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
//   'Delhi', 'Jammu and Kashmir', 'Ladakh'
// ];

// const ManageProfile = ({ userData, setResponse }) => {
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     user_name: '',
//     shop_name: '',
//     mobile: '',
//     email: '',
//     address: '',
//     city: '',
//     state: '',
//     pincode: '',
//     gst_no: '',
//     pass: '',
//     dealer_type: '',
//   });

//   const [isEditing, setIsEditing] = useState(false);

//   // Pre-fill form with userData
//   useEffect(() => {
//     if (userData) {
//       setFormData({
//         user_name: userData.user_name || '',
//         shop_name: userData.shop_name || '',
//         mobile: userData.mobile || '',
//         email: userData.email || '',
//         address: userData.address || '',
//         city: userData.city || '',
//         state: userData.state || '',
//         pincode: userData.pincode || '',
//         gst_no: userData.gst_no || '',
//         pass: userData.pass || '',
//         dealer_type: userData.dealer_type || 'Admin',
//       });
//     }
//   }, [userData]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleEditProfile = async () => {
//     const mobilePattern = /^[0-9]{10}$/;
//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const pincodePattern = /^[1-9][0-9]{5}$/;

//     if (formData.mobile && !mobilePattern.test(formData.mobile)) {
//       setResponse({ message: 'Enter valid 10-digit mobile number.', status: 'error' });
//       setTimeout(() => setResponse(''), 3000);
//       return;
//     }

//     if (formData.email && !emailPattern.test(formData.email)) {
//       setResponse({ message: 'Enter valid email address.', status: 'error' });
//       setTimeout(() => setResponse(''), 3000);
//       return;
//     }

// setLoading(true);
//     try {
//       const response = await fetch(`https://api.hargharmart.com/update-profile/${userData.id}`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify(formData),
//       });

//       const result = await response.json();

//       if (response.ok) {
//         setLoading(false);
//                     localStorage.setItem('userData', JSON.stringify(result));
//         setResponse({ message: 'Profile updated successfully.', status: 'success' });
//         setIsEditing(false);
//             setTimeout(() => {setResponse('');
//         window.location.reload();
//             }, 2000);
//       } else {
//         setLoading(false);
//         setResponse({ message: 'Something Went Wrong. Try Again Later', status: 'error' });
//     setTimeout(() => setResponse(''), 2000);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <>
//     <section className='my-4'>
//       <div className='px-4'>
//         <p className='page-title'>Manage Profile</p>

//         <div className='row g-3 mt-1'>
//           {[
//             { label: 'Your Name', name: 'user_name' },
//             { label: 'Shop Name', name: 'shop_name' },
//             { label: 'Mobile', name: 'mobile', type: 'tel' },
//             { label: 'Email', name: 'email', type: 'email' },
//             // { label: 'GST No', name: 'gst_no' },
//             // { label: 'Password', name: 'pass' },
//             { label: 'Address', name: 'address' },
//             // { label: 'City', name: 'city' },
//             // { label: 'Pincode', name: 'pincode', type: 'number' },
//           ].map(({ label, name, type = 'text' }) => (
//             <div key={name}>
//                 <div className='profile-input px-0'>
//               <label className='profile-label'>{label}</label>
//               <input
//                 type={type}
//                 className='profile-control'
//                 name={name}
//                 value={formData[name]}
//                 onChange={handleInputChange}
//                 disabled={!isEditing}
//               />
//               </div>
//             </div>
//           ))}

//   <div className='col-lg-6'>
//     <div className='profile-input px-0'>
//       <label className='profile-label'>GST No</label>
//       <input
//         type='text'
//         className='profile-control'
//         name='gst_no'
//         value={formData.gst_no}
//         onChange={handleInputChange}
//         disabled={!isEditing}
//       />
//     </div>
//   </div>

//   <div className='col-lg-6'>
//     <div className='profile-input px-0'>
//       <label className='profile-label'>Password</label>
//       <input
//         type='text'
//         className='profile-control'
//         name='pass'
//         value={formData.pass}
//         onChange={handleInputChange}
//         disabled={!isEditing}
//       />
//     </div>
//   </div>


//   <div className='col-lg-6'>
//     <div className='profile-input px-0'>
//       <label className='profile-label'>City</label>
//       <input
//         type='text'
//         className='profile-control'
//         name='city'
//         value={formData.city}
//         onChange={handleInputChange}
//         disabled={!isEditing}
//       />
//     </div>
//   </div>

//           <div className='col-lg-6'>
//           <div className='profile-input px-0'>
//             <label className='profile-label'>State</label>
//             <select
//               name='state'
//               className='profile-control'
//               value={formData.state}
//               onChange={handleInputChange}
//               disabled={!isEditing}
//             >
//               <option value="">Select State</option>
//               {indianStates.map((state) => (
//                 <option key={state} value={state}>
//                   {state}
//                 </option>
//               ))}
//             </select>
//           </div>
//           </div>

//             <div>
//     <div className='profile-input px-0'>
//       <label className='profile-label'>Pincode</label>
//       <input
//         type='number'
//         className='profile-control'
//         name='pincode'
//         value={formData.pincode}
//         onChange={handleInputChange}
//         disabled={!isEditing}
//       />
//     </div>
// </div>


//         </div>

//         <div className='mt-4'>
//           {isEditing ? (
//             <>
//               <button className='edit-btn me-2' onClick={handleEditProfile}>
//                 Save Changes
//               </button>
//               <button className='close-btn' onClick={() => setIsEditing(false)}>
//                 Cancel
//               </button>
//             </>
//           ) : (
//             <button className='edit-btn' onClick={() => setIsEditing(true)}>
//               Edit Profile
//             </button>
//           )}
//         </div>
//       </div>
//     </section>

//     {loading && <Loading setLoading={setLoading} />}

// </>
// );
// };

// export default ManageProfile;





import React, { useState, useEffect } from "react";
import "../css/components/ManageProfile.css";
import Loading from "../general/Loading";

import {
  FaUser,
  FaStore,
  FaPhoneAlt,
  FaEnvelope,
  FaFileInvoice,
  FaLock,
  FaMapMarkerAlt,
  FaCity,
  FaMap,
  FaMapPin,
  FaUserCircle,
  FaEdit,
  FaSave,
  FaTimes,
} from "react-icons/fa";

const indianStates = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
];

const ManageProfile = ({ userData, setResponse }) => {
  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [formData, setFormData] = useState({
    user_name: "",
    shop_name: "",
    mobile: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    gst_no: "",
    pass: "",
    dealer_type: "",
  });

  useEffect(() => {
    if (userData) {
      setFormData({
        user_name: userData.user_name || "",
        shop_name: userData.shop_name || "",
        mobile: userData.mobile || "",
        email: userData.email || "",
        address: userData.address || "",
        city: userData.city || "",
        state: userData.state || "",
        pincode: userData.pincode || "",
        gst_no: userData.gst_no || "",
        pass: userData.pass || "",
        dealer_type: userData.dealer_type || "",
      });
    }
  }, [userData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditProfile = async () => {
    const mobilePattern = /^[0-9]{10}$/;
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (formData.mobile && !mobilePattern.test(formData.mobile)) {
      setResponse({
        message: "Enter Valid Mobile Number",
        status: "error",
      });

      setTimeout(() => setResponse(""), 2000);
      return;
    }

    if (formData.email && !emailPattern.test(formData.email)) {
      setResponse({
        message: "Enter Valid Email",
        status: "error",
      });

      setTimeout(() => setResponse(""), 2000);
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `https://api.hargharmart.com/update-profile/${userData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        localStorage.setItem("userData", JSON.stringify(result));

        setLoading(false);

        setResponse({
          message: "Profile Updated Successfully",
          status: "success",
        });

        setIsEditing(false);

        setTimeout(() => {
          setResponse("");
          window.location.reload();
        }, 1500);
      } else {
        setLoading(false);

        setResponse({
          message: result.message,
          status: "error",
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <>
      <section className="container-fluid py-4">

        <div className="profile-card">

          {/* Header */}

          <div className="profile-header">

            <div className="profile-avatar">
              <FaUserCircle size={65} />
            </div>

            <div className="profile-details">

              <h3>{formData.user_name}</h3>

              <p>{formData.shop_name}</p>

              <span className="badge bg-primary px-3 py-2">
                {formData.dealer_type}
              </span>

            </div>

            <div className="ms-auto">

              {!isEditing ? (

                // <button
                //   className="btn btn-primary rounded-pill px-4"
                //   onClick={() => setIsEditing(true)}
                // >
                //   <FaEdit size={26} className="me-2" />
                //   Edit Profile
                // </button>
                <button
  className=" edit-profile-btn"style={{background:"Var(--blue)",color:"#fff"}}
  onClick={() => setIsEditing(true)}
>
  <FaEdit size={18} className="me-2" />
  Edit Profile
</button>

              ) : (

                <>
                  <button
                    className="btn btn-success rounded-pill px-4 me-2"
                    onClick={handleEditProfile}
                  >
                    <FaSave size={26} className="me-2" />
                    Save
                  </button>

                  <button
                    className="btn btn-outline-danger rounded-pill px-4"
                    onClick={() => setIsEditing(false)}
                  >
                    <FaTimes size={26} className="me-2" />
                    Cancel
                  </button>
                </>

              )}

            </div>

          </div>

          <hr />

          <div className="row g-4">
            {/* Full Name */}
<div className="col-lg-6">
  <label className="form-label profile-label">
    <FaUser size={26} className="text-primary me-2" />
    Full Name
  </label>

  <input
    type="text"
    className="form-control profile-control"
    name="user_name"
    value={formData.user_name}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* Shop Name */}
<div className="col-lg-6">
  <label className="form-label profile-label">
  <FaStore size={26} className="text-warning me-2" />
    Shop Name
  </label>

  <input
    type="text"
    className="form-control profile-control"
    name="shop_name"
    value={formData.shop_name}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* Mobile */}
<div className="col-lg-6">
  <label className="form-label profile-label">
    <FaPhoneAlt size={26} className="text-success me-2" />
    Mobile Number
  </label>

  <input
    type="tel"
    className="form-control profile-control"
    name="mobile"
    value={formData.mobile}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* Email */}
<div className="col-lg-6">
  <label className="form-label profile-label">
    <FaEnvelope size={26} className="text-danger me-2" />
    Email Address
  </label>

  <input
    type="email"
    className="form-control profile-control"
    name="email"
    value={formData.email}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* GST */}
<div className="col-lg-6">
  <label className="form-label profile-label">
    <FaFileInvoice size={26} className="text-info me-2" />
    GST Number
  </label>

  <input
    type="text"
    className="form-control profile-control"
    name="gst_no"
    value={formData.gst_no}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* Password */}
<div className="col-lg-6">
  <label className="form-label profile-label">
    <FaLock size={26} className="text-secondary me-2" />
    Password
  </label>

  <input
    type="password"
    className="form-control profile-control"
    name="pass"
    value={formData.pass}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* Address */}
<div className="col-12">
  <label className="form-label profile-label">
    <FaMapMarkerAlt size={26} className="text-danger me-2" />
    Address
  </label>

  <textarea
    rows="4"
    className="form-control profile-control"
    name="address"
    value={formData.address}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* City */}
<div className="col-lg-4">
  <label className="form-label profile-label">
    <FaCity size={26} className="text-primary me-2" />
    City
  </label>

  <input
    type="text"
    className="form-control profile-control"
    name="city"
    value={formData.city}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

{/* State */}
<div className="col-lg-4">
  <label className="form-label profile-label">
    <FaMap size={26} className="text-success me-2" />
    State
  </label>

  <select
    className="form-select profile-control"
    name="state"
    value={formData.state}
    onChange={handleInputChange}
    disabled={!isEditing}
  >
    <option value="">Select State</option>

    {indianStates.map((state) => (
      <option key={state} value={state}>
        {state}
      </option>
    ))}
  </select>
</div>

{/* Pincode */}
<div className="col-lg-4">
  <label className="form-label profile-label">
    <FaMapPin size={26} className="text-warning me-2" />
    Pincode
  </label>

  <input
    type="number"
    className="form-control profile-control"
    name="pincode"
    value={formData.pincode}
    onChange={handleInputChange}
    disabled={!isEditing}
  />
</div>

          </div> {/* row */}

        </div> {/* profile-card */}

      </section>

      {loading && <Loading setLoading={setLoading} />}

    </>
  );
};

export default ManageProfile;
       